import type { PropsWithChildren } from "react";
import { BuilderUI } from "@circle-react-shared/BuilderUI";

export const DefaultCanvas = ({
  children,
}: PropsWithChildren<Record<string, unknown>>) => (
  <BuilderUI.Canvas className="relative overflow-hidden">
    <BuilderUI.CanvasZoomableSize className="h-full origin-center p-6">
      <BuilderUI.CanvasCard className="h-[calc(100%-64px)]">
        <BuilderUI.TailwindFrame className="rounded-lg">
          {children}
        </BuilderUI.TailwindFrame>
      </BuilderUI.CanvasCard>
    </BuilderUI.CanvasZoomableSize>
  </BuilderUI.Canvas>
);
